export default `<p>
    <span style="font-family: 等线">投保本保险前，投保人应如实告知本保险以下投保前提条件有关的情况，确认符合下列所有投保前提条件方可进行投保，若保险合同订立后发现不符合下列任何投保前提条件的，则视为投保人故意未依法履行如实告知义务。</span>
</p>
<p>
    <strong><span style="font-family: 等线">&nbsp;</span></strong>
</p>
<p>
    <strong><span style="font-family: 等线">投保前提条件：</span></strong>
</p>
<p style="text-indent: 28px">
    <span style="font-family: 等线">1. </span><span style="font-family: 等线">投保人不属于以下保险公司不接受投保的行业之一：渔业、森林砍伐业、矿业采石业、航运业以及涉及隧道作业、地下作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业。</span>
</p>
<p style="text-indent: 28px">
    <span style="font-family: 等线">2. </span><span style="font-family: 等线">任何提出投保申请的人员或在保险期间内提出参保申请的人员均符合本保险约定的团体成员资格。本保险约定的团体成员资格须同时满足以下要求：</span>
</p>
<p style="text-indent:28px">
    <span style="font-family: 等线"><strong>（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。</strong></span>
</p>
<p style="text-indent:28px">
    <span style="font-family: 等线"><strong>本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇用的情形。约定的团体成员投保年龄限制：18-65周岁。</strong></span>
</p>
<p style="text-indent:28px">
    <span style="font-family: 等线"><strong>（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，<a name="OLE_LINK1"></a><a name="OLE_LINK2"></a>中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。</strong></span>
</p>
<p style="text-indent: 28px">
    <span style="font-family: 等线">3. </span><span style="font-family: 等线">投保人未曾被任何保险公司拒绝投保申请，未曾被任何保险公司拒绝保险合同续保，未曾被任何保险公司解除保险合同，且未曾被任何保险公司要求加费或附加特别约定方可承保。</span>
</p>
<p style="text-indent: 28px">
    <span style="font-family: 等线">4. </span><span style="font-family: 等线">投保人（包括子公司和分支机构）在下列这些国家或地区中不存在风险*：古巴、伊朗、叙利亚、朝鲜、乌克兰克里米亚地区、卢甘斯克、顿涅茨克</span>
</p>
<p style="text-indent:28px">
    <span style="font-family: 等线">*</span><span style=";font-family:等线"> “</span><span style=";font-family:等线">风险”是指下列任一情形：</span>
</p>
<p style="margin-left: 0;text-indent: 28px">
    <span style=";font-family:&#39;Times New Roman&#39;,serif">i.<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span style=";font-family:等线">投保人的注册地、住所地或运营地位于上述任何国家或地区。</span>
</p>
<p style="margin-left: 0;text-indent: 28px">
    <span style=";font-family:&#39;Times New Roman&#39;,serif">ii.<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span style=";font-family:等线">投保人所从事的业务活动（例如：服务、货运、销售、供应渠道、投保财产）涉及上述任何国家或地区。</span>
</p>
<p style="margin-left: 0;text-indent: 28px">
    <span style=";font-family:&#39;Times New Roman&#39;,serif">iii.<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;font-family: &#39;Times New Roman&#39;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span style=";font-family:等线">投保人的董事会成员或高级管理人员住所地在上述任何国家或地区，或者投保人的大股东（包括个人或者实体）的注册地、住所地或居住地在上述任何国家或地区。</span>
</p>
<p style="text-indent:28px">
    <span style="font-family: 等线">&nbsp;</span>
</p>
<p>
    <span style="font-size: 14px;font-family: 等线">对于上述任何一项投保前提条件，如投保人未进行确认的，则保险公司不接受投保人投保本保险的申请；对于上述第2项投保前提条件，如本保险投保时投保人确认符合该项投保前提条件，但任何投保人员在保险合同订立后或在保险合同有效期内发现不符合的，则<strong>保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。</strong></span>
</p>
<p>
    <br/>
</p>
<style type="text/css">
    p{
        margin-bottom: 0
    }
</style>

`
